import General from "@ecoenghk/general";
import moment from "moment";
const gs = new General();

/**
 * @param {"success"|"error"|"info"|"warning"} status
 * @param {number} opacity 0-1
 * @returns {string}
 */
export const messageColor = (status, opacity = 0) => {
  const c = {
    success: `rgba(0, 128, 0, ${opacity})`,
    error: `rgba(255, 0, 0, ${opacity})`,
    info: `rgba(46,134,193, ${opacity})`,
    warning: `rgba(212,172,13,${opacity})`
  }
  return c[status] || `rgba(144,148,151, ${opacity})`;
}
export const showBigProgress = (dispatch) => {
  dispatch({ type: "SHOW_BIG_PROGRESS" });
};
export const hideBigProgress = (dispatch) => {
  dispatch({ type: "HIDE_BIG_PROGRESS" });
};
/**
 *
 * @param {*} dispatch
 * @param {string} title
 * @param {"info"|"success"|"warning"|"error"} severity
 * @param {2000|number} timeMs
 */
export const openSnackbar = (dispatch, title, severity, timeMs) => {
  dispatch({
    type: "OPENED_SNACKBAR",
    payload: {
      title: title || "",
      severity: severity || "info",
      time: timeMs || 2000,
    },
  });
};

/**
 * @param {dispatch} dispatch
 * @param {string} title
 * @param {function} onConfirm
 * @param {function} onCancel
 * @param {function} callback
 * @param {boolean} showWindowConfirmAlertSign
 */
export const confirmWindow = (
  dispatch,
  title,
  onConfirm,
  onCancel,
  callback,
  showWindowConfirmAlertSign
) => {
  dispatch({
    type: "WINDOW_CONFIRM",
    payload: {
      status: true,
      title: title,
      onConfirm: onConfirm,
      onCancel: onCancel,
      callback: callback,
      showWindowConfirmAlertSign: showWindowConfirmAlertSign,
    },
  });
};

/**
 * @param {dispatch} dispatch
 * @param {string} title
 * @param {function} onConfirm
 */
export const promptWindow = (dispatch, title, onConfirm, defaultValue) => {
  dispatch({
    type: "WINDOW_PROMPT",
    payload: {
      status: true,
      title: title,
      onConfirm: onConfirm,
      defaultValue: defaultValue,
    },
  });
};
/**
 * @param {dispatch} dispatch
 * @param {string} title
 * @param {function} onClose
 */
export const alertWindow = (dispatch, title, onClose) => {
  dispatch({
    type: "WINDOW_ALERT",
    payload: {
      status: true,
      windowAlertTitle: title,
      windowAlertOnClose: onClose,
    },
  });
};
/**
 * 
 * @param {dispatch} dispatch 
 * @param {String} title 
 * @param {Function(buttonContent, index)} windowButtonsOnChoose 
 * @param {Array} windowBtnContentArray 
 * @param {Function} windowButtonsOnCancel 
 */
export const buttonsWindow = (dispatch, title, windowButtonsOnChoose, windowBtnContentArray, windowButtonsOnCancel) => {
  dispatch({
    type: "WINDOW_BUTTONS",
    payload: {
      status: true,
      title: title,
      windowButtonsOnChoose: windowButtonsOnChoose,
      windowButtonsOnCancel: windowButtonsOnCancel,
      windowBtnContentArray: windowBtnContentArray,
    },
  });
};
/**
 * @param {dispatch} dispatch
 * @param {string} title
 * @param {boolean} isSuccess
 * @param {"success"|"error"|"info"|"warning"} severity
 */
export const addMultiSnackbarMsg = async (dispatch, title, isSuccess, severity) => {
  if (!dispatch) return;
  let status;
  if (severity) status = severity;
  else status = isSuccess ? "success" : "error";
  dispatch({ type: "ADD_MULTI_SNACKBAR_MSG", payload: { title, status } });
}
export const addMapDeviceBubbleMsg = (state, dispatch, deviceID, message) => {
  let mapDeviceMessage = state.mapDeviceMessage;
  let mapDeviceMessageArray = state.mapDeviceMessageArray;
  const obj = { deviceID, message, timeStamp: moment().valueOf() };
  mapDeviceMessage[deviceID] = message;
  mapDeviceMessageArray.unshift(obj);
  if (mapDeviceMessageArray.length > 100) mapDeviceMessageArray.pop();
  dispatch({
    type: "SET_GENERAL_MANY_STATE",
    payload: {
      mapDeviceMessage: mapDeviceMessage,
      mapDeviceMessageArray: mapDeviceMessageArray
    }
  })
}
